import React, { Component } from 'react';
import { Container } from 'reactstrap';

import FAQ from '../faq/FAQ';

class FAQContainer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Container fluid className={'eir-faq-container eir-theme-' + (this.props.theme ? this.props.theme : 'default') + ' ' + (!this.props.theme || this.props.theme == 'default' ? 'mb-6 mt-6' : 'pb-6 pt-6')} >
        <Container>
            <FAQ {...this.props}/>
        </Container>
      </Container>
    );
  }
}

export default FAQContainer;
